import * as React from 'react';
import { ProgressBar as ProgressBarStandard } from '@emorg-prd/standard-react';
import './ProgressBar.css';

interface ProgressBarProps extends Omit<React.ComponentProps<typeof ProgressBarStandard>, 'value'> {
    className?: string;
    indeterminate?: boolean;
    value?: number; // Made optional and overrides the original 'value'
}

const ProgressBar = (props: ProgressBarProps) => {

    return (
            <ProgressBarStandard
                {...props}
                optionalClass={`${props.className} progressBar-Style`}
                type={props.indeterminate ? "indeterminate" : props.type}
                value={props.value ?? 0}
            />
        )
}

export { ProgressBar };